// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","Bluecheese":"#615CFF","Oyster":"#C0C5C9","mainText":"G608a19","link":"Gd7e520 Gc3ece6"};